import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ReactSVG } from 'react-svg';

import { editContent, InnerContent } from '../../../modules/editor';
import { RootState } from '../../../modules';

import ButtonGroup from '../../../components/Button/ButtonGroup';

type Props = {
	innerContent: InnerContent;
	style: any;
	contentId: number;
	contentIndex: number;
};

function ShareToolbar({ innerContent, style, contentId, contentIndex }: Props) {
	const dispatch = useDispatch();	
	const [showCropModal, setShowCropModal] = useState(false);
	
	const editor = useSelector((state: RootState) => state.editor);

	const iconImage = require.context('../../../assets/images/', true);

	const contentTarget = `${contentId}/content/${contentIndex}`;
	const styleTarget = `${contentId}/style/${contentIndex}`;

	let cropper:any = {};

	const openCropModal = () => {		
		setShowCropModal(true);
	}

	const closeCropModal = () => {
		setShowCropModal(false);
	}

	return (
		<>
			<div className="toolbar partition">
				<div className="group">
          <ButtonGroup
						target={`${styleTarget}/box/textAlign`}
						value={style.textAlign}
						options={editor.option.ctaAlign}
						imagePath="icon/toolbar/button_align_"
						imageType="svg"
						disabled={false}
					/>
				</div>
			</div>
		</>
	);
}

export default ShareToolbar;